<div class="col-sm-12 flex justify-content-center" style="color: #0063b9">
  <h5>
    <i class="fa-solid fa-truck-fast" style="margin-right: 10px"></i>
    {{ tipo }}
  </h5>
</div>
<hr />
<div class="row" *ngIf="despacho">
  <div class="col-sm-12">
    <label>Dirección : </label> {{ direccion?.address ?? '' }}
  </div>
  <div class="col-sm-12" *ngIf="direccion?.city">
    <label>Comuna : </label> {{ direccion?.city ?? '' }}
  </div>
  <div class="col-sm-12" *ngIf="!fechas">
    <label>Fecha de Entrega : </label>
    {{ despacho.requestedDate | date : 'dd/MM/yyyy' | uppercase }}
  </div>
  <ng-container *ngIf="fechas">
    <div class="col-sm-12" *ngFor="let item of fechas">
      <label>Fecha de Entrega : </label>
      {{ item | date : 'dd/MM/yyyy' | uppercase }}
    </div>
  </ng-container>
</div>
